import TextField from 'components/form/text'
import { SelectField } from 'components/form/select'
import ChoiceField from 'components/form/choice'
import PhoneField from 'components/form/phone'
import { useI18n } from 'locales'

const CustomField = ({
  className, label, required, name, error,
  format, value, answerChoices, includeOther, onFocus, onChange
}) => {
  const { i18n } = useI18n()
  const baseProps = { className, label, required, name, error, onFocus }
  const onTextInputChange = (event) => onChange({ value: event.target.value })
  const onChoiceChange = (choiceValue) => onChange({ value: choiceValue })

  return (
    <>
      {format === 'string' && (
        <TextField
          {...baseProps}
          type="text"
          onChange={onTextInputChange}
          value={value}
          autoComplete="chrome-off" // this makes chrome disable autofill, any non-standard value would work
        />
      )}
      {format === 'text' && (
        <TextField
          {...baseProps}
          type="textarea"
          onChange={onTextInputChange}
          value={value}
        />
      )}
      {format === 'choices_one' && (
        <ChoiceField
          {...baseProps}
          type="one"
          values={answerChoices}
          includeCustomOption={includeOther}
          onChange={onChoiceChange}
          selectedItems={value}
        />
      )}
      {format === 'select' && (
        <SelectField
          {...baseProps}
          options={answerChoices.map((choice) => ({ value: choice, name: choice }))}
          onChange={onChoiceChange}
          value={value}
          placeholder={i18n.t('booking.templates.questions.placeholders.select')}
        />
      )}
      {format === 'choices_many' && (
        <ChoiceField
          {...baseProps}
          type="many"
          values={answerChoices}
          includeCustomOption={includeOther}
          onChange={onChoiceChange}
          selectedItems={value}
        />
      )}
      {format === 'phone_number' && (
        <PhoneField
          {...baseProps}
          onChange={onChange}
          number={value || ''}
        />
      )}
    </>
  )
}

export default CustomField
